// src/config/tutorReview.js
//
// BLANK-but-valid Model-B scaffold (Slice 1 de-seed). The Model-A bundle/credit-pack/quota
// demo data is removed entirely. Tutor Review is now a per-submission paid add-on on the
// shared /serviceRequests lifecycle (Slice B); these fields are admin-set copy/flags that
// Slice C will surface. NO prices, NO bundles, NO demo content.
//   enabled            - master on/off for the Tutor Review add-on
//   storefrontTagline  - short line advertising the add-on
//   feeDescription     - how Danielle charges (shown on the submit page)
//   turnaroundNote     - expected turnaround copy
export const DEFAULT_TUTOR_REVIEW_SETTINGS = {
    enabled: false,
    storefrontTagline: '',
    feeDescription: '',
    turnaroundNote: ''
};
